import { render, staticRenderFns } from "./ProfileHistory.vue?vue&type=template&id=10e8a0c1"
import script from "./ProfileHistory.vue?vue&type=script&lang=js"
export * from "./ProfileHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports